import React, { Component } from 'react';
import { createComponent, customMap } from 'redux-form-antd';
import { Upload, Icon, notification, Button } from 'antd';
import get from 'lodash/get';
import InlineMessage from '../../atoms/InlineMessage';

class UploadDialogCSVContainer extends Component {
  state = {
    errorMessage: false,
    fileList: [],
    loading: false,
  };

  beforeUpload = file => {
    this.setState({ errorMessage: false });

    const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv';

    if (!isCSV) {
      notification.error({
        message: 'Error',
        description: 'You can only upload a CSV file!',
        duration: 0,
      });
      this.setState({ loading: false, fileUrl: null });
    }

    return isCSV;
  };

  handleChange = info => {
    let { fileList } = info;

    // 1. Limit the number of uploaded files
    //    Only to show two recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-1);

    // 2. read from response and show file link
    fileList = fileList.map(file => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.url;
      }
      return file;
    });

    // 3. filter successfully uploaded files according to response from server
    fileList = fileList.filter(file => {
      if (file.response) {
        return !!file.response.id;
      }
      return true;
    });

    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    }

    if (info.file.status === 'error') {
      const errorMessage = get(info, 'file.response.error', 'File could not be uploaded.');

      this.setState({
        errorMessage,
        fileUrl: null,
        loading: false,
      });
    }

    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.setState({
        loading: false,
      });

      // Call the redux-form dispatch
      this.props.onChange({ file: info.file.originFileObj, name: info.file.name });
    }

    this.setState({ fileList });
  };

  render() {
    const { fileUrl, fileList, loading, errorMessage } = this.state;
    const { token } = JSON.parse(localStorage.getItem('user'));

    const uploadButton = (
      <Button>
        <Icon type={loading ? 'loading' : 'upload'} /> Upload CSV
      </Button>
    );

    return (
      <div>
        {errorMessage && <InlineMessage type="error" message={errorMessage} />}
        <Upload
          name={this.props.name}
          showUploadList
          fileList={fileList}
          onRemove={() => this.setState({ loading: false, fileUrl: null })}
          action={this.props.action}
          beforeUpload={this.beforeUpload}
          onChange={this.handleChange}
          headers={{
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          }}
        >
          {fileUrl || uploadButton}
        </Upload>
      </div>
    );
  }
}

// redux-form mapper
function mapUploadCSVDialog(
  mapProps,
  { input: { value: omitValue, onChange, onBlur, ...inputProps }, meta: omitMeta, ...props }
) {
  return {
    ...mapProps,
    onChange,
    onBlur,
  };
}
const UploadDialogCSV = createComponent(UploadDialogCSVContainer, customMap(mapUploadCSVDialog));

export default UploadDialogCSV;
